// Validate safe internal redirect URLs
export const isSafeRedirectUrl = (url?: string | null): boolean => {
  if (!url || typeof url !== "string") return false;
  // Must start with a single slash (negative lookahead blocks //), no path traversal
  return /^\/(?!\/)[\w\-./?=&%#]*$/.test(url) && !url.includes("..");
};
